import {
    CKYC_DATA_REQUEST,
    CKYC_DATA_ERROR,
    CKYC_DATA_SUCCESS,
    FETCH_IFSC_CODE_REQUEST,
    FETCH_IFSC_CODE_SUCCESS,
    FETCH_IFSC_CODE_ERROR,
    GET_INPUT_IFSC_CODE,
    FETCH_IFSC_CODE_RESET,
    CONNECT_FETCH_KYC_REQUEST,
    CONNECT_FETCH_KYC_SUCCESS,
    CONNECT_FETCH_KYC_ERROR,
    CKYC_CONFIRMATION_REQUEST,
    CKYC_CONFIRMATION_SUCCESS,
    CKYC_CONFIRMATION_ERROR,
    FETCH_BANK_DETAIL_ERROR,
    FETCH_BANK_DETAIL_SUCCESS,
    FETCH_BANK_DETAIL
} from "../actionType";

const initialState = {
    isLoading: false,
    ifscData: null,
    kycError: null,
    ifscValue: null,
    kycValue: null,
    ifscError: null,
    kycBankDetails: null,
    connectFetchKycData: null,
    connectFetchKycError: null,
    ckycConfirmData: null,
    ckycConfirmError: null,
    accountTypeData: ['Savings', 'Current',],
    bankDetailResponse: null,
    bankDetailError: null
};

const connectBankReducer = (state = initialState, action: any) => {
    const { type, payload } = action;
    switch (type) {
        case CKYC_DATA_REQUEST:
            return {
                ...state,
                kycValue: action.value,
                isLoading: true
            };
        case CKYC_DATA_ERROR:
            return {
                ...state,
                isLoading: false,
                kycError: payload,
            }
        case CKYC_DATA_SUCCESS:
            return {
                ...state,
                isLoading: false,
                kycBankDetails: payload
            }
        case GET_INPUT_IFSC_CODE:
            return {
                ...state,
                ifscValue: payload,
            }
        case FETCH_IFSC_CODE_REQUEST:
            return {
                ...state,
                isLoading: false,
                ifscError: null
            }
        case FETCH_IFSC_CODE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                ifscData: payload,
                ifscError: null
            }
        case FETCH_IFSC_CODE_ERROR:
            return {
                ...state,
                isLoading: false,
                ifscData: null,
                ifscError: payload
            }
        case FETCH_IFSC_CODE_RESET:
            return {
                ...state,
                ifscData: null,
                kycError: null,
                ifscError: null,
            }
        case CONNECT_FETCH_KYC_REQUEST:
            return {
                ...state,
                isLoading: false,
            }
        case CONNECT_FETCH_KYC_SUCCESS:
            return {
                ...state,
                isLoading: false,
                connectFetchKycData: payload
            }
        case CONNECT_FETCH_KYC_ERROR:
            return {
                ...state,
                isLoading: false,
                connectFetchKycError: payload
            }
        case CKYC_CONFIRMATION_REQUEST:
            return {
                ...state,
                isLoading: true,
            }
        case CKYC_CONFIRMATION_SUCCESS:
            return {
                ...state,
                isLoading: false,
                ckycConfirmData: payload
            }
        case CKYC_CONFIRMATION_ERROR:
            return {
                ...state,
                isLoading: false,
                ckycConfirmError: payload
            }
        case FETCH_BANK_DETAIL:
            return {
                ...state
            }
        case FETCH_BANK_DETAIL_SUCCESS:
            return {
                ...state,
                bankDetailResponse: payload
            }
        case FETCH_BANK_DETAIL_ERROR:
            return {
                ...state,
                bankDetailError: payload
            }
        default:
            return state;
    }
}

export default connectBankReducer;